/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relativedayagoone3Inputs */

const en_relativedayagoone3 = /** @type {(inputs: Relativedayagoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 day ago`)
};

const pt_relativedayagoone3 = /** @type {(inputs: Relativedayagoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`há 1 dia`)
};

/**
* | output |
* | --- |
* | "1 day ago" |
*
* @param {Relativedayagoone3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativedayagoone3 = /** @type {((inputs?: Relativedayagoone3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativedayagoone3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativedayagoone3(inputs)
	return pt_relativedayagoone3(inputs)
});
export { relativedayagoone3 as "relativeDayAgoOne" }